<template>
  <div v-if="showDashboard">
    <v-container fluid grid-list-xl>
      <v-flex xs12 md8 offset-md2 margin-auto>
        <v-flex xs12 text-xs-center mb-4>
          <div>
            <div class="left">
              <v-select class="selectBox" label="Select States" v-model="selectedState" :items="AllStates" item-text="name" item-value="code" @change="getRecordsOf"></v-select>
            </div>
            <div class="right">
              <v-select class="selectBox" label="Select Status" v-model="selectedStatus" :items="['Open', 'Booked', 'Completed']" @change="getInstallationOrders2()"></v-select>
            </div>
          </div>
          <div style="clear:both;" class="mb-5">
            <v-btn large class="mx-0 border-btn" :class="cmClicked ? 'bg-blueish' : ''" @click="cmClicked=true, inClicked=false, selectedType='CM', getInstallationOrders2()">Check Measure</v-btn>
            <v-btn large class="mx-0 border-btn" :class="inClicked ? 'bg-blueish' : ''" @click="cmClicked=false, inClicked=true, selectedType='Install', getInstallationOrders2()">Install</v-btn>
          </div>
        </v-flex>
      </v-flex>
      <v-flex xs12 md8 offset-md2 margin-auto mt-5>
        <!-- <div class="responsive-table mt-5 pb-5">
          <table width='100%'>
            <template>
              <thead>
                <tr>
                  <th width="10%">Order Code</th>
                  <th width="20%">Name</th>
                  <th width="50%">Address</th>
                  <th width="20%">Date Ordered</th>
                </tr>
              </thead>
              <tbody>

              </tbody>
            </template>
          </table>
        </div> -->
        <v-layout row wrap class="bg-greyy2 text-xs-center fs24 bold border-bottom2 border">
          <v-flex pa-2 xs2>
            Order Code
          </v-flex>
          <v-flex pa-2 xs2>
            Name
          </v-flex>
          <v-flex pa-2 :class="selectedStatus === 'Open' ? 'xs4': 'xs3'">
            Address
          </v-flex>
          <v-flex pa-2 xs2 v-if="selectedType === 'CM' && ['Booked', 'Completed'].includes(selectedStatus)">
            CM Booked Date
          </v-flex>
          <v-flex pa-2 xs2 v-if="selectedType === 'Install' && ['Booked', 'Completed'].includes(selectedStatus)">
            Install Booked Date
          </v-flex>
          <v-flex pa-2 xs2>
            Date Ordered
          </v-flex>
          <v-flex pa-2 :class="selectedStatus === 'Open' ? 'xs2': 'xs1'">
            Actions
          </v-flex>
        </v-layout>
        <v-layout justify-center align-center mt-5 v-if="loading">
            <v-progress-circular
            indeterminate
            color="primary">
            </v-progress-circular>
        </v-layout>
        <v-layout v-else-if="orders.length===0" row wrap class="text-xs-center fs24">
          <v-flex xs12 class="bg-greyy">
            No Record found
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap v-for="(order, index) in orders" :key="index" class="text-xs-center fs24 border">
          <v-flex xs2 class="bg-greyy bold border-right2">
            <div class="pa-2">
              {{order.orderCode}}
            </div>
          </v-flex>
          <v-flex xs2>
            <div class="pa-2">
              {{order.customerID.firstName}} {{order.customerID.lastName}}
            </div>
          </v-flex>
          <v-flex v-if="order.address && order.differentShippingAddress" :class="selectedStatus === 'Open' ? 'xs4': 'xs3'">
            <div class="pa-2">
              {{order.address.address}} {{order.address.city}}, {{order.address.state}}, {{order.address.postcode}}
            </div>
          </v-flex>
          <v-flex v-else-if="order.customerID.address" :class="selectedStatus === 'Open' ? 'xs4': 'xs3'">
            <div class="pa-2">
              {{order.customerID.address.address}} {{order.customerID.address.city}}, {{order.customerID.address.state}}, {{order.customerID.address.postcode}}
            </div>
          </v-flex>
          <v-flex xs2 v-if="selectedType === 'CM' && ['Booked', 'Completed'].includes(selectedStatus)">
            <div class="pa-2"  v-html="getFormatedDate(order.cmBookedDate)">
            </div>
          </v-flex>
          <v-flex xs2 v-if="selectedType === 'Install' && ['Booked', 'Completed'].includes(selectedStatus)">
            <div class="pa-2"  v-html="getFormatedDate(order.installBookedDate)">
            </div>
          </v-flex>
          <v-flex xs2>
            <div class="pa-2"  v-html="getFormatedDate(order.date)">
            </div>
          </v-flex>
          <v-flex :class="selectedStatus === 'Open' ? 'xs2': 'xs1'">
            <v-select class="selectBox2" @change="quoteActions" :items="actionItems(order, index)" label="Actions"></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="bookCMDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>Book Check Measure</h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs10 sm6 margin-auto text-sm-center>
            <h2 class="my-4">Add CM Book Date and Time </h2>
            <v-text-field class="xs10" v-model="datetime" @click="showDate = true" label='CM Booked Date'></v-text-field>
            <v-btn v-if="!showDate && !showTime" color="grey" dark class="large-buttons cursor-pointer" @click="updateCMBookedDate()">Book CM</v-btn>
          </v-flex>
          <v-flex xs12 sm12 text-sm-center v-if="showDate">
            <v-date-picker v-model="datePicker" @click:date='dateClicked'></v-date-picker>
          </v-flex>
          <v-flex xs12 sm12 text-sm-center v-if="showTime">
            <v-time-picker v-model="timePicker" @click:minute='minuteClicked'></v-time-picker>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" @click="bookCMDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bookInstallDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>Book Install</h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs10 sm6 margin-auto text-sm-center>
            <h2 class="my-4">Add Install Book Date and Time </h2>
            <v-text-field class="xs10" v-model="datetime" @click="showDate = true" label='Install Booked Date'></v-text-field>
            <v-btn v-if="!showDate && !showTime" color="grey" dark class="large-buttons cursor-pointer" @click="updateInstallBookedDate()">Book Install</v-btn>
          </v-flex>
          <v-flex xs12 sm12 text-sm-center v-if="showDate">
            <v-date-picker v-model="datePicker" @click:date='dateClicked'></v-date-picker>
          </v-flex>
          <v-flex xs12 sm12 text-sm-center v-if="showTime">
            <v-time-picker v-model="timePicker" @click:minute='minuteClicked'></v-time-picker>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" @click="bookInstallDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OrderService from '@/services/OrderService'
import moment from 'moment'
export default {
  data: () => ({
    selectedIndex: null,
    datePicker: new Date().toISOString().substr(0, 10),
    timePicker: moment().format('h:mmA'),
    datetime: moment().format('YYYY-MM-DD h:mm A'),
    datetime2: moment().format(),
    showDate: false,
    showTime: false,
    snackbar: false,
    popupText: null,
    bookCMDialog: false,
    bookInstallDialog: false,
    loading: false,
    selectedState: '',
    selectedStatus: 'Open',
    selectedType: 'CM',
    AllStates: [
      { code: '', name: 'All' },
      { code: 'VIC', name: 'Victoria' },
      { code: 'NSW', name: 'New South Wales' },
      { code: 'QLD', name: 'Queensland' },
      { code: 'ACT', name: 'Australian Capital Territory' },
      { code: 'SA', name: 'South Australia' },
      { code: 'WA', name: 'Western Australia' },
      { code: 'NT', name: 'Northern Territory' },
      { code: 'TAS', name: 'Tasmania' }
    ],
    orders: [],
    AllStatus: [],
    cmClicked: true,
    inClicked: false,
    loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
    showDashboard: false
  }),
  mounted () {
    this.cmClicked = true
    if (this.loggedInUser.email === 'books@diyblinds.com.au') {
      this.showDashboard = false
    } else if (this.loggedInUser.position && ['installations', 'manager'].includes(this.loggedInUser.position.role)) {
      this.showDashboard = true
    }
    this.getInstallationOrders2()
  },
  methods: {
    async updateCMBookedDate () {
      let params = {id: this.orders[this.selectedIndex]._id, dateAndTime: this.datetime2}
      let response = await OrderService.updateCMBookedDate(params)
      if (response.data.success) {
        this.updateInstallationStatus('CM Booked')
      }
    },
    async updateInstallBookedDate () {
      let params = {id: this.orders[this.selectedIndex]._id, dateAndTime: this.datetime2}
      let response = await OrderService.updateInstallBookedDate(params)
      if (response.data.success) {
        this.updateInstallationStatus('Install Booked')
      }
    },
    async updateInstallationStatus (status) {
      let order = this.orders[this.selectedIndex]
      let params = {id: order._id, installationStatus: status}
      let response = await OrderService.updateInstallationStatus(params)
      if (response.data.success) {
        this.popupText = 'Installation status updated successfully.'
        this.snackbar = true
        this.bookCMDialog = false
        this.bookInstallDialog = false
        this.getInstallationOrders2()
      }
    },
    dateClicked () {
      this.datetime = moment(this.datePicker + ' ' + this.timePicker).format('YYYY-MM-DD h:mm A')
      this.showDate = false
      this.showTime = true
    },
    minuteClicked () {
      this.datetime = moment(this.datePicker + ' ' + this.timePicker).format('YYYY-MM-DD h:mm A')
      this.datetime2 = moment(this.datePicker + ' ' + this.timePicker).format()
      this.showTime = false
    },
    actionItems (order, index) {
      let returnArray = []
      returnArray.push({text: 'Download Invoice', value: {action: 'pdfInvoice', id: order._id, orderCode: order.orderCode}})
      returnArray.push({text: 'Download Pretty Quote', value: {action: 'pretty', id: order._id, orderCode: order.orderCode}})
      returnArray.push({text: 'Download CM Sheet', value: {action: 'cmSheet', id: order._id, orderCode: order.orderCode}})
      if (this.selectedStatus === 'Open' && this.selectedType === 'CM') {
        returnArray.push({text: 'Book CM', value: {action: 'bookCM', id: order._id, orderCode: order.orderCode, index: index}})
      }
      if (this.selectedStatus === 'Booked' && this.selectedType === 'CM') {
        returnArray.push({text: 'Complete CM', value: {action: 'completeCM', id: order._id, orderCode: order.orderCode, index: index}})
      }
      if (this.selectedStatus === 'Completed' && this.selectedType === 'CM') {
        // returnArray.push({text: 'Open for Install', value: {action: 'openInstall', id: order._id, orderCode: order.orderCode, index: index}})
      }
      if (this.selectedStatus === 'Open' && this.selectedType === 'Install') {
        returnArray.push({text: 'Book Install', value: {action: 'bookInstall', id: order._id, orderCode: order.orderCode, index: index}})
      }
      if (this.selectedStatus === 'Booked' && this.selectedType === 'Install') {
        returnArray.push({text: 'Complete Install', value: {action: 'completeInstall', id: order._id, orderCode: order.orderCode, index: index}})
      }
      return returnArray
    },
    async quoteActions (value) {
      switch (value.action) {
        case 'bookCM':
          this.selectedIndex = value.index
          this.bookCMDialog = true
          break
        case 'completeCM':
          this.selectedIndex = value.index
          this.updateInstallationStatus('CM Completed')
          break
        // case 'openInstall':
        //   this.selectedIndex = value.index
        //   this.updateInstallationStatus('Install Open')
        //   break
        case 'bookInstall':
          this.selectedIndex = value.index
          this.bookInstallDialog = true
          break
        case 'completeInstall':
          this.selectedIndex = value.index
          this.updateInstallationStatus('Install Completed')
          break
        case 'pdfInvoice':
          this.pdfInvoice(value.id, value.orderCode)
          break
        case 'pretty':
          this.prettyQuote(value.id, value.orderCode)
          break
        case 'cmSheet':
          const response = await OrderService.downloadCMSheet(value.id)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `CMSheet-${value.orderCode}.xlsx`)
          document.body.appendChild(link)
          link.click()
          link.remove()

          this.popupText = 'CMSheet XLSX generated.'
          this.snackbar = true
          break
      }
    },
    async pdfInvoice (id, orderCode) {
      console.log('getting invoice')
      const response = await OrderService.getOrderInvoice(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF invoice generated'
      this.snackbar = true
    },

    async prettyQuote (id, orderCode) {
      const response = await OrderService.getPrettyOrderQuote(id)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', orderCode + '.pdf')
      document.body.appendChild(link)
      link.click()
      link.remove()

      this.popupText = 'PDF pretty quote generated'
      this.snackbar = true
    },
    getFormatedDate (date, format = 'DD/MM/YYYY') {
      return moment(date).format(format)
    },
    getRecordsOf (value) {
      if (value === '') {
        this.selectedState = 'All'
      } else {
        this.selectedState = value
      }
      this.getInstallationOrders2()
    },
    async getInstallationOrders2 () {
      this.loading = true
      var params = {state: this.selectedState, status: this.selectedStatus, type: this.selectedType}
      let response = await OrderService.getInstallationOrders2(params)
      console.log(response.data)
      if (response.data.success === true) {
        this.orders = response.data.orders
        this.loading = false
      }
    },
    async showInstallationDashboardModal (order) {
    }
  },
  components: {}
}
</script>

<style scoped>

.pinkk {
  color: #ea4d76;
}
.responsive-table {
  display: block;
  width: 100%;
  overflow-x: auto;
}
td {
  vertical-align: top !important;
}
.mHeight {
  min-height: 550px;
  max-height: 550px;
  overflow: auto;
}
.greyy {
  color: #565e6f;
}
.greenn {
  color:#19ec81;
}
.cursor-pointer {
  cursor: pointer;
}
.margin-auto {
  margin: 0 auto;
}
.bg-greyy {
  background-color: #dcdcdc !important;
}
.bg-greyy2 {
  background-color: #bec0bf !important;
}
.bg-blueish {
  background-color: #9ebbcf !important;
}
.fs24 {
  font-size: 24px;
}
.v-list__tile__title {
  font-size: 24px !important;
}
.bold {
  font-weight: bold;
}
.border .flex {
  border: 1px solid #d1d1d1;
}
.border-right2 {
  border-right: 2px solid #404040;
}
.border-bottom2 {
  border-bottom: 2px solid #404040;
}
.border-btn {
  border: 2px solid #404040;
}
.v-btn--large {
  height: 70px;;
  font-size: 30px;
}
.selectBox {
  font-size: 26px !important;
  max-width: 370px;
}
.selectBox2 .v-select__slot label {
  font-size: 26px !important;
}
.large-buttons{
  font-size: 20px;
  width: 250px;
  margin-left: 0;
}
@media (max-width: 661px) {
  .fs24 {
    font-size: 14px;
  }
  .v-btn--large {
    height: 60px;;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InstallDashboardNew.vue